import axios from 'axios'

export default  {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    generate({commit}, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/projects/billings/generate/${id}`)
          .then(res => {
            resolve(res.data.data.project)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    find({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/projects/${id}`)
          .then(res => {
            resolve(res.data.data.project)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    create({commit}, project) {
      return new Promise((resolve, reject) => {
        axios
          .post('/projects', project)
          .then(res => {
            resolve(res.data.data.project)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    update({commit}, project) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/projects/${project.id}`, project)
          .then(res => {
            resolve(res.data.data.project)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    delete({commit}, projectId) {
      return new Promise((resolve, reject) => {
        axios.delete(`/projects/${projectId}`)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    restore({commit}, projectId) {
      return new Promise((resolve, reject) => {
        axios.put(`/projects/${projectId}/restore`)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    cancel({commit}, cancelData) {
      return new Promise((resolve, reject) => {
        axios.post(`/projects/${cancelData.project_id}/cancel`, cancelData)
          .then(res => {
            resolve(res.data.data.project)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getApprovalUsersList({commit}, projectId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/projects/${projectId}/approval-users-list`)
          .then(res => {
            resolve(res.data.data.datas)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getExamsStatusList({commit}, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/projects/${data.project_id}/exams-status-list`, {
            params: data,
          })
          .then(res => {
            resolve(res.data.data.exams)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getBillingLines({commit}, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/projects/${data.project_id}/billing-lines`)
          .then(res => {
            resolve(res.data.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    saveServicesFromLocation({commit}, services) {
      return new Promise((resolve, reject) => {
        axios
          .post('/projects/save-services-from-location', services)
          .then(res => {
            resolve(res.data.data.project)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

  },

  getters: {},
}
